import css from '@styled-system/css';
import '../media/Img.js';
import { Icon } from '../media/Icon.js';
import { Box } from '../layout/Box.js';
import { Stack } from '../layout/Stack.js';
import { AnimatedBox } from '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import '../typography/Text.js';
import '../typography/Display.js';
import { Heading } from '../typography/Heading.js';
import '../typography/Label.js';
import { Paragraph } from '../typography/Paragraph.js';
import React__default from 'react';
import styled from 'styled-components';

var ToastContainer = styled(AnimatedBox)(css({
    p: "16px",
    backgroundColor: "toastBackground",
    backdropFilter: "blur(80px)",
    borderRadius: "16px",
    maxWidth: "744px",
    cursor: "default",
    width: ["calc(100vw - 32px)", "744px"],
    zIndex: "toast",
    boxShadow: "toast",
    flexGrow: 1,
    mb: "12px",
    ":last-child": {
        mb: 0,
    },
}));
var CloseIcon = styled(Icon)(css({
    color: "grey.1",
    fontSize: "20px",
    cursor: "pointer",
    transition: "color 200ms",
    ":hover": {
        color: "textPrimary",
    },
}));
var variants = {
    initial: {
        opacity: 0,
        y: -24,
    },
    animate: {
        opacity: 1,
        y: 0,
        x: 0,
        scale: 1,
        transition: {
            duration: 0.4,
            ease: [0.4, 0, 0.2, 1],
        },
    },
    exit: {
        opacity: 0,
        scale: 0.85,
        transition: {
            duration: 0.2,
            ease: [0.4, 0, 1, 1],
        },
    },
};
var Toast = function (_a) {
    var variant = _a.variant, title = _a.title, text = _a.text, onClose = _a.onClose, icon = _a.icon, duration = _a.duration;
    React__default.useEffect(function () {
        var timeout = setTimeout(onClose, duration);
        return function () { return clearTimeout(timeout); };
    }, [duration, onClose]);
    var getIcon = function () {
        if (icon) {
            return icon;
        }
        switch (variant) {
            case "success":
                return "check_circle_fill";
            case "error":
                return "cancel_fill";
            case "warning":
                return "alert_circle_fill";
        }
    };
    var getColor = function () {
        switch (variant) {
            case "success":
                return "alert.green";
            case "error":
                return "alert.red";
            case "warning":
                return "alert.orange";
        }
    };
    return (React__default.createElement(ToastContainer, { className: "toast-container", variants: variants, initial: "initial", animate: "animate", exit: "exit", layout: true },
        React__default.createElement(Box, { display: "flex", justifyContent: "space-between", alignItems: "center", minHeight: "36px" },
            React__default.createElement(Box, { flexGrow: 1, display: "flex", alignItems: "center" },
                React__default.createElement(Icon, { icon: getIcon(), color: getColor(), fontSize: "24px" }),
                React__default.createElement(Stack, { direction: "column", spacing: "2px", ml: "16px" },
                    title && React__default.createElement(Heading, { size: "sm" }, title),
                    React__default.createElement(Paragraph, { size: title ? "sm" : "md" }, text))),
            onClose && React__default.createElement(CloseIcon, { icon: "close", onClick: onClose }))));
};

export { Toast };
//# sourceMappingURL=Toast.js.map
